import { Translate } from "react-i18nify";
import { useNavigate } from "react-router";
import { LBtn, LFlex } from "@components";
import { NavItems } from "@helpers/navigation";
import { AssessmentShell } from "../components/AssessmentShell";

export const AssessmentBeginPracticeRun = (): JSX.Element => {
    const navigate = useNavigate();

    const handleNavigateToTestRun = (): void => {
        navigate(NavItems.Assessments.PracticeTestRun.path);
    };

    return (
        <AssessmentShell micVolume={0} micIsRecording={false}>
            <LFlex alignCenter justifyCenter>
                <p className="has-text-dark-blue is-size-3">
                    <Translate value="assessments.practiceRound" />
                </p>
                <LBtn
                    verticalSpacing="5"
                    isLarge
                    onClick={handleNavigateToTestRun}
                    isBold
                    classes="is-size-2"
                    smallTopBottomMargins
                >
                    <Translate value="assessments.start" />
                </LBtn>
            </LFlex>
        </AssessmentShell>
    );
};
